import * as React from 'react';

import { Box, Typography } from '@mui/material';

type DetailRowProps = {
  label: React.ReactNode;
  description?: string | null | React.ReactNode;
  labelColor?: string;
};

const DetailRow: React.FC<DetailRowProps> = ({ label, description, labelColor }) => {
  const isNode = typeof description === 'object' && description !== null;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
        py: 1,
        borderBottom: '1px solid #E6E6E6',
        '&:last-of-type': { borderBottom: 'none' },
      }}
    >
      <Typography
        sx={{
          fontSize: '13px',
          color: labelColor || '#848484',
          fontWeight: 400,
          fontFamily: 'Poppins',
          flexShrink: 0,
        }}
      >
        {label}
      </Typography>
      {isNode ? (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', gap: 0.5 }}>
          {description}
        </Box>
      ) : (
        <Typography
          sx={{
            fontSize: '13px',
            color: '#111',
            fontWeight: 400,
            fontFamily: 'Poppins',
            textAlign: 'right',
          }}
        >
          {description}
        </Typography>
      )}
    </Box>
  );
};

export default DetailRow;
